// SEO-related constants
export const DEFAULT_OG_IMAGE = "https://ackodrive-assets.ackodrive.com/media/OG_IMAGE.png";

export const CAR_DROP_OG_IMAGE = "https://ackodrive-assets.ackodrive.com/media/CAR_DROP_OG_IMAGE.webp";

export const OG_IMAGE_DIMENSIONS = {
  width: 1200,
  height: 630,
} as const;

export const TWITTER_CARD_TYPE = "summary_large_image" as const;

export const DEFAULT_ROBOTS = {
  index: true,
  follow: true,
} as const;

export const NO_INDEX_FOLLOW_ROBOTS = {
  index: false,
  follow: true,
} as const;

export const NO_INDEX_NO_FOLLOW = "noindex, nofollow";

export const BASE_APP_URL = process.env.NEXT_PUBLIC_FRONTEND_URL || "";
